module.exports = __webpack_public_path__ + "static/media/Banner_MiniGame.f039fc05.png";